import React, { createContext, useContext, useState, useCallback } from 'react';

const PRIORITIZE_SECTION_KEYS = ['no-due-date', 'today', 'work-in-progress', 'later', 'done'];

const PrioritizeSectionsContext = createContext(null);

export function PrioritizeSectionsProvider({ children }) {
  const [expandedPrioritizeSections, setExpandedPrioritizeSections] = useState(
    () => new Set(PRIORITIZE_SECTION_KEYS)
  );
  const [visiblePrioritizeSections, setVisiblePrioritizeSections] = useState(
    () => new Set(PRIORITIZE_SECTION_KEYS.filter(k => k !== 'work-in-progress'))
  );

  const togglePrioritizeSection = useCallback((section) => {
    setExpandedPrioritizeSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(section)) {
        newSet.delete(section);
      } else {
        newSet.add(section);
      }
      return newSet;
    });
  }, []);

  const togglePrioritizeSectionVisibility = useCallback((section) => {
    setVisiblePrioritizeSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(section)) {
        newSet.delete(section);
      } else {
        newSet.add(section);
      }
      return newSet;
    });
  }, []);

  const value = {
    expandedPrioritizeSections,
    togglePrioritizeSection,
    visiblePrioritizeSections,
    togglePrioritizeSectionVisibility
  };

  return (
    <PrioritizeSectionsContext.Provider value={value}>
      {children}
    </PrioritizeSectionsContext.Provider>
  );
}

export function usePrioritizeSectionsContext() {
  const context = useContext(PrioritizeSectionsContext);
  if (!context) {
    throw new Error('usePrioritizeSectionsContext must be used within a PrioritizeSectionsProvider');
  }
  return context;
}
